<template>
    <vs-row>
        <vs-col vs-lg="4" vs-sm="12" class="flex items-center p-1">
            <span class="material-icons-outlined small_icon">event</span>
            <label>Date of Birth</label>
        </vs-col>
        <vs-col vs-lg="8" vs-sm="12" class="flex justify-between items-center p-1">
            <flat-pickr v-if="editBox"
            v-model="teacherPersonalDetails.bio.dob"
          />
            <p v-else>{{teacherPersonalDetails.bio.dob?teacherPersonalDetails.bio.dob:'Not Available'}}</p>
            <vs-tooltip position="top" color="primary" text="Edit" v-if="havePermission && !editBox">
              <vs-button icon="border_color" type="border" @click="handleEdit" >
              <!-- <span class="material-icons-outlined small_icon cursor-pointer" ></span> -->
              </vs-button>
            </vs-tooltip>
            <vs-tooltip position="top" color="primary" text="Save" v-if="editBox">
              <vs-button icon="save" type="border" @click="updateBio">
              <!-- <span class="material-icons-outlined small_icon cursor-pointer">save</span> -->
              </vs-button>
            </vs-tooltip>
        </vs-col>
        <vs-col vs-lg="4" vs-sm="12" class="flex items-center p-1">
            <span class="material-icons-outlined small_icon">flag</span>
            <label>Nationality</label>
        </vs-col>
        <vs-col vs-lg="8" vs-sm="12" class="flex items-center p-1">
            <vs-input v-if="editBox" v-model="teacherPersonalDetails.bio.nationality" />
             <p v-if="!editBox">{{teacherPersonalDetails.bio.nationality?teacherPersonalDetails.bio.nationality:'Not Available'}}</p>
        </vs-col>
        <vs-col vs-lg="4" vs-sm="12" class="flex items-center p-1">
            <span class="material-icons-outlined small_icon">language</span>
            <label>Website</label>
        </vs-col>
        <vs-col vs-lg="8" vs-sm="12" class="flex items-center p-1">
            <vs-input v-if="editBox" v-model="teacherPersonalDetails.bio.website" />
            <p v-else>{{teacherPersonalDetails.bio.website?teacherPersonalDetails.bio.website:'Not Available'}}</p>
        </vs-col>
        <vs-col vs-lg="4" vs-sm="12" class="flex p-1">
            <span style="margin-top: 4px;" class="material-icons-outlined small_icon">person</span>
            <label>Biography</label>
        </vs-col>        
        <vs-col vs-lg="8" vs-sm="12" class="flex items-end p-1">
          <vs-textarea v-if="editBox" v-model="teacherPersonalDetails.bio.biodata" />
            <p v-else style="max-height: 100px; overflow: auto" class="vertical_scrollbar">{{teacherPersonalDetails.bio.biodata?teacherPersonalDetails.bio.biodata:'Not Available'}}</p>
            <!-- <a v-if="teacherPersonalDetails.bio.biodata" style="white-space: nowrap; cursor: pointer;" class="inline-block" @click="showMore = !showMore">
                <span v-if="showMore">Read More</span>
                <span v-else>Show Less</span>
            </a> -->
        </vs-col> 
    </vs-row>  
</template>

<script>
import { TeacherUpdate } from '@/api/teacher'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
export default {
  components: {
    flatPickr
  },
  props: {
    teacherPersonalDetails:{
      default:{}
    },
    havePermission:{
      default: false
    },
    updateTeacher:{
      default:()=>{}
    }
  },
  data () {
    return {
      showMore: true,
      editBox: false
    }
  },
  methods: {
    handleEdit () {
      console.log('YONO',this.teacherPersonalDetails.basic_details.active_user == 0)
      if (this.teacherPersonalDetails.basic_details.active_user == 0) {
        this.$vs.notify({
          title: 'Warning',
          text: 'Action can not be performed as staff is inactive',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
      this.editBox = true
    },
    async updateBio () {
      try {
        const customer_id = localStorage.getItem('customer_id')
        const payload = {
          updateField: {
            bio:this.teacherPersonalDetails.bio
          }
        }
        const { data } = await TeacherUpdate(
          payload,
          this.$route.params.teacher_id,
          customer_id
        )
        this.editBox = false
        // this.setAfterUpdate(data)
        this.$vs.notify({
          title: 'Updated',
          text: 'Staff Updated Successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
        return data
      } catch (e) {
        this.$vs.notify({
          title: 'Error',
          text: e.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
      
    }
  }
}
</script>